import React from 'react'
import { useNewTranslation } from 'hooks/index'
import { SubmissionProgressProps } from 'state/review'
import { parseBackendDate } from 'services/dates'
import { Country } from 'services/api/constants'
import Text, { IndicatorColor, TextColor } from 'particles/Text'
import styled from 'styled-components'
import { spacing } from 'particles/styles'
import Icon from 'particles/Icon'
import { differenceInDays } from 'date-fns'

interface SubmittedAtDisplayProps {
    submissionProgress: SubmissionProgressProps
    country: Country
    isTaskPending?: boolean
    mt?: string
}

const SubmittedAtDisplay: React.FC<SubmittedAtDisplayProps> = ({ submissionProgress, country, isTaskPending, mt }) => {
    const [newT] = useNewTranslation()

    const daySinceSubmitted = submissionProgress.submitted_at
        ? differenceInDays(new Date(), new Date(submissionProgress.submitted_at))
        : undefined
    const daySinceSubmittedTextDisplay = daySinceSubmitted === 0 ? '< 1' : daySinceSubmitted
    const daySinceSubmittedTextColor: TextColor | IndicatorColor =
        daySinceSubmitted && daySinceSubmitted >= 5 ? 'ribbonRed' : 'black'

    return submissionProgress.submitted_at ? (
        <SubmittedAtContainer mt={mt}>
            <Icon name="clock" size="16px" />
            <Text scale="caption400" style={{ textAlign: 'left' }}>
                {newT('card.submission.submittedDate', {
                    defaultValue: 'Submitted on {{submittedDate}}',
                    submittedDate: parseBackendDate(submissionProgress.submitted_at, country, { showTime: true }),
                })}
            </Text>

            {/* Still using hard code english 'day' text in this implementation */}
            {isTaskPending && typeof daySinceSubmitted === 'number' && (
                <Text
                    scale="caption400"
                    color={daySinceSubmittedTextColor}
                    style={{ textAlign: 'left', whiteSpace: 'nowrap' }}
                >
                    {`(${daySinceSubmittedTextDisplay} ${daySinceSubmitted > 1 ? 'days' : 'day'})`}
                </Text>
            )}
        </SubmittedAtContainer>
    ) : null
}
export default SubmittedAtDisplay

const SubmittedAtContainer = styled.div<{ mt?: string }>`
    display: flex;
    margin-top: ${p => p.mt || spacing[100]};
    gap: ${spacing[100]};
`
